import { Cookie } from '@nuxt-common/util/app/utils/cookie';
import { useNavUser } from '~/stores/navUser';

const COOKIE_SESSION_NAMES = {
  FORWARD_PAGE: 'FORWARDPAGE_KEY',
  APPLY_NOW: 'applyNow',
};

const isApplyNowFlowActive = () => {
  try {
    const applyNowDataString = sessionStorage.getItem(COOKIE_SESSION_NAMES.APPLY_NOW);

    if (!applyNowDataString) {
      return false;
    }

    const { value, expiry } = JSON.parse(applyNowDataString);

    if (Date.now() > expiry) {
      sessionStorage.removeItem(COOKIE_SESSION_NAMES.APPLY_NOW);
      return false;
    }

    return value === 'true';
  } catch {
    sessionStorage.removeItem(COOKIE_SESSION_NAMES.APPLY_NOW);
    return false;
  }
};

const isCurrentPathSame = () => {
  try {
    const forwardPage = Cookie.get(COOKIE_SESSION_NAMES.FORWARD_PAGE);

    if (!forwardPage) {
      return false;
    }

    const decodedForwardPage = decodeURIComponent(forwardPage);
    const forwardPath = new URL(decodedForwardPage, location.origin).pathname;
    return location.pathname === forwardPath;
  } catch {
    return false;
  }
};

function isSignedInOrSoftSignedIn() {
  const navUser = useNavUser();

  return !!(navUser.data.isSignedIn || navUser.data.username);
}

export default function isCitiRedirect() {
  return isApplyNowFlowActive() && isSignedInOrSoftSignedIn() && isCurrentPathSame();
}
